// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DynamicRowsController from "./dynamic_rows_controller"
application.register("dynamic-rows", DynamicRowsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import PeriodFilterController from "./period_filter_controller"
application.register("period-filter", PeriodFilterController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import PetSearchController from "./pet_search_controller"
application.register("pet-search", PetSearchController)

import InlineAttachmentsController from "./inline_attachments_controller"
application.register("inline-attachments", InlineAttachmentsController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import ChatComposerController from "./chat_composer_controller"
application.register("chat-composer", ChatComposerController)

import SourceFieldsController from "./source_fields_controller"
application.register("source-fields", SourceFieldsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import VariantPickerController from "./variant_picker_controller"
application.register("variant-picker", VariantPickerController)
